import './Home.css';

export default function Home(){
    return(
        <>
          <div className="home">
            <div className="content">
            <h2>"Advanced Imaging for Optimal Oral Health"</h2>
            <h4>Welcome to 3rd i Dental Scan, where cutting-edge technology meets exceptional care.<br></br>Our advanced dental imaging services provide high-resolution scans that ensure precise diagnostics for all your dental needs. With a focus on accuracy, efficiency, and patient comfort, 3rd i Dental Scan is dedicated to supporting dental professionals in delivering top-tier oral healthcare. Let us help you see the full picture of your smile.</h4>
            
            </div>
         </div>
         
        <div className="boxes">
                <div className="box1">
                    <img src='https://images.pexels.com/photos/4269362/pexels-photo-4269362.jpeg'/>
                    <p>Implant</p>
                </div>
                <div className="box1">
                <img src='https://images.pexels.com/photos/3779698/pexels-photo-3779698.jpeg'/>
                    <p>Book Health Checkup</p>
                </div>
                <div className="box1">
                <img src=' https://images.pexels.com/photos/3845810/pexels-photo-3845810.jpeg'/>
                    <p>Consult Online</p>
                </div>
                
            </div>

        </>
    )
}


 
